export const ID = 'ID';
export const NAME = 'NAME';
export const USERNAME = 'USERNAME';
export const EMAIL = 'EMAIL';
export const PASSWORD = 'PASSWORD';
export const PASSWORD_CONFIRMATION = 'PASSWORD_CONFIRMATION';
export const CREATED_AT = 'CREATED_AT';
export const ROLE = 'ROLE';
export const COUNTRY = 'COUNTRY';
export const SCHOOL = 'SCHOOL';
export const ADDRESS = 'ADDRESS';
export const SERIAL = 'SERIAL';
export const ENABLED = 'ENABLED';
export const LOCKED = 'LOCKED';
export const COURSES = 'COURSES';
export const STUDENT_COURSE = 'STUDENT_COURSE';
export const USER_FILL_INFO = 'USER_FILL_INFO';
export const USER_CLEAR_INFO = 'USER_CLEAR_INFO';
export const TIMEZONE = 'TIMEZONE';
export const DEFAULT_LANGUAGE = 'DEFAULT_LANGUAGE';



// WEBPACK FOOTER //
// ./src/store/modules/user/mutation-types.js